import React from 'react';
import { FileArrowUp, FileText, SealCheck } from '@phosphor-icons/react';
import HaleConsoleLayout from '../../components/hale/HaleConsoleLayout';
import { T, FONT, PageHeading, ConsoleCard, Eyebrow } from './_theme';

/* Documents — Uploaded Files, Reports, Certificates.
 * Document storage is provisioned as brands progress through review;
 * until then each panel shows an honest empty state (no placeholder data). */

const PANELS = [
  { icon: FileArrowUp, key: 'Uploaded Files', desc: 'Formulations, specs, and supporting files you share with the Hale team.' },
  { icon: FileText,    key: 'Reports',        desc: 'Scientific review reports and assessments issued by ToxIntel + Aᴳ.' },
  { icon: SealCheck,   key: 'Certificates',   desc: 'Membership badges and compliance certificates once issued.' },
];

export default function HaleDocumentsPage() {
  return (
    <HaleConsoleLayout>
      <PageHeading title="Documents" sub="Your Hale brand files, scientific review reports, and certificates in one place." testid="hale-documents-title" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5" data-testid="hale-documents-grid">
        {PANELS.map((p) => (
          <ConsoleCard key={p.key} data-testid={`hale-doc-${p.key.toLowerCase().split(' ')[0]}`}>
            <Eyebrow>{p.key}</Eyebrow>
            <div className="rounded-lg border border-dashed p-8 text-center" style={{ borderColor: T.LINE, backgroundColor: T.NEUTRAL }}>
              <p.icon size={24} weight="duotone" style={{ color: T.MUTED }} className="mx-auto mb-3" />
              <p className="text-[13px] font-semibold" style={{ color: T.INK }}>No {p.key.toLowerCase()} yet</p>
              <p className="text-[12px] mt-1.5" style={{ color: T.MUTED }}>{p.desc}</p>
            </div>
          </ConsoleCard>
        ))}
      </div>
      <p className="mt-6 text-[12px]" style={{ color: T.MUTED, fontFamily: FONT.MONO }}>
        Documents become available as your application progresses through Hale review.
      </p>
    </HaleConsoleLayout>
  );
}
